import { PlainDate } from "@sa-nu/shared-utils/date";
import {
  RESERVATION_RULE_REVISION_2027_FIRST_APPLICABLE_NIGHT,
  RESERVATION_RULE_REVISION_2027_START_DATE,
} from "@sa-nu/shared-utils/reservation-rule-2027";

import type { UnavailablePeriod } from "../../dx/ui/date-picker";

const LEGACY_LEAD_MONTHS = 3;

// 旧ルール(3 ヶ月前)の宿泊と新ルール(6 ヶ月前)の宿泊の間にできる、まだ予約できない期間。
// BE は 12 時前なら基準日を前日にするが、ここは時刻を見ないため 12 時前は境界が 1 日ずれる。
// 移行期間だけのコードなので、RRU-102 (cutover 完了後の cleanup) で削除する。
function getReservationLeadTimeGap(
  today: PlainDate,
): { startDate: PlainDate; endDate: PlainDate } | null {
  if (PlainDate.compare(today, RESERVATION_RULE_REVISION_2027_START_DATE) < 0) {
    return null;
  }
  const startDate = today.add({ months: LEGACY_LEAD_MONTHS, days: 1 });
  const endDate =
    RESERVATION_RULE_REVISION_2027_FIRST_APPLICABLE_NIGHT.subtract({ days: 1 });
  return PlainDate.compare(startDate, endDate) <= 0
    ? { startDate, endDate }
    : null;
}

/**
 * 予約開始リードタイムの切替で生じる「まだ予約できない期間」を DatePicker 用の注記つきで返す。
 * 穴は常に 2027 年内に収まるため、終了側の年は省く。
 */
export function buildLeadTimeUnavailablePeriods(
  today: PlainDate,
): UnavailablePeriod[] {
  const gap = getReservationLeadTimeGap(today);
  if (gap === null) return [];
  const { startDate, endDate } = gap;
  return [
    {
      startDate,
      endDate,
      note: `${startDate.year}年${startDate.month}月${startDate.day}日〜${endDate.month}月${endDate.day}日は、3ヶ月前から予約可能です`,
    },
  ];
}
